import React from "react";
import { useField } from "formik";
import { FormField } from "semantic-ui-react";

export default function MyTransparentTextInput({ label, ...props }) {
  const [field, meta] = useField(props);
  return (
    <FormField style={{ margin: 0 }} error={meta.touched && !!meta.error}>
      <label>{label}</label>
      <input {...field} {...props} />
      {meta.touched && meta.error ? (
        <div className="error-message">{meta.error}</div>
      ) : null}
    </FormField>
  );
}
